export const environment = {
  production: true,
  apiEndpoint: 'https://api-dev.myrest.io/',
};
